import { ca } from '@cian/analytics';

import { EAnalyticsKey } from '../../types/chatHint';
import { TOffer } from '../../types/offer';
import { getProducts } from '../../utils/trackings_helpers';

export const trackHintQuestionClick = (offer: TOffer | undefined, questionName: EAnalyticsKey) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Messages',
    action: 'click_sopr',
    label: 'short_question',
    products: offer ? getProducts([offer], { questionName }) : [],
  });
};
